import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { offerRows } from '../../data/content';
const includes = ['Accesso a vita a tutto il materiale', 'Tutti gli aggiornamenti futuri inclusi', 'Nessun costo ricorrente', 'Paghi una sola volta'];
export function Offer() {
  return <section id="offerta" className="w-full bg-[#0E3B42] px-5 py-14 sm:px-6 sm:py-20" data-id="element-179" data-mp="3a4np82nrqzev">
      <div className="mx-auto max-w-2xl" data-id="element-180" data-mp="3f2yxi8yf11uz">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#E9BE62]" data-id="element-181" data-mp="3jv8hl8cun7pc">
          🏆 Offerta speciale di lancio
        </p>
        <h2 className="mt-3 text-center font-display text-[1.7rem] font-bold leading-[1.14] text-white sm:text-[2.4rem]" data-id="element-182" data-mp="3nwc0k3q71jus">
          Oggi non stai acquistando un semplice PDF.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-183" data-mp="1qf41fnktawq">
          Stai integrando nella tua pratica clinica un Percorso Clinico che
          organizza ogni decisione relativa all’utilizzo dei GLP-1.
        </p>

        <div className="mt-9 overflow-hidden rounded-2xl bg-white/[0.06] ring-1 ring-white/15" data-id="element-184" data-mp="1bka386cm2toi">
          <div className="flex items-center justify-between px-4 py-3 text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-white/50 sm:px-5" data-id="element-185" data-mp="16m8jdj7d2qbz">
            <span data-id="element-186" data-mp="23b6cyy3dki7k">Contenuto</span>
            <span data-id="element-187" data-mp="1zamik2a6rsp4">Valore</span>
          </div>
          <ul data-id="element-188" data-mp="1zbnxwiy8j1cn">
            {offerRows.map(row => <li key={row.name} className="flex items-start justify-between gap-4 border-t border-white/10 px-4 py-3.5 sm:px-5" data-id="element-189" data-mp="1ujeb3bsf2hel">
                <span className="text-[14px] leading-snug text-white/90" data-id="element-190" data-mp="1piqiilojhsi9">
                  {row.name}
                </span>
                <span className="shrink-0 font-display text-[15px] font-bold text-white/70" data-id="element-191" data-mp="2i8p241jysxfj">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 border-t border-white/20 bg-white/[0.06] px-4 py-4 sm:px-5" data-id="element-192" data-mp="364kc9xwsy25p">
              <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-[#E9BE62]" data-id="element-193" data-mp="2sdyr22jvlg4n">
                Valore totale
              </span>
              <span className="font-display text-xl font-bold text-white line-through decoration-[#E9BE62]/70 decoration-2" data-id="element-194" data-mp="2wcnyzfm5a5gw">
                €472
              </span>
            </li>
          </ul>
        </div>

        <div className="mt-9 rounded-2xl bg-white p-6 text-center sm:p-8" data-id="element-195" data-mp="2nbpxb3z6ia1h">
          <p className="text-[14.5px] leading-snug text-[#3F5F64]" data-id="element-196" data-mp="29g47wvp19o8j">
            Ma poiché questa è la fase di lancio, oggi puoi ottenere l’accesso
            completo per soli:
          </p>
          <p className="mt-2 font-display text-[4.25rem] font-bold leading-none tracking-[-0.03em] text-[#0E3B42] sm:text-[5.5rem]" data-id="element-197" data-mp="7ng2cfox2opl">
            €19
          </p>
          <p className="mt-1 text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#17808D]" data-id="element-198" data-mp="1w5sp4mzpji97">
            Pagamento unico
          </p>
          <p className="mt-3 text-[13.5px] font-semibold text-[#4A6B70]" data-id="element-199" data-mp="1s6tlr6tmjtjv">
            Un solo pagamento, senza abbonamenti né costi mensili.
          </p>

          <p className="mx-auto mt-4 flex max-w-sm items-start gap-2 rounded-xl bg-[#EEF6F7] p-3 text-left text-[12.5px] font-medium leading-snug text-[#0E3B42]" data-id="element-200" data-mp="215f1ku7pougy">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#17808D]" aria-hidden="true" data-id="element-201" data-mp="2fwe87zozl8xw" />
            <span data-id="element-202" data-mp="2ovhqj1gbxkbc">
              Il cambio di valuta è automatico: paghi l’equivalente di €19 nella
              moneta del tuo Paese, senza alcun calcolo da fare.
            </span>
          </p>

          <ul className="mx-auto mt-5 grid max-w-sm gap-2.5 text-left" data-id="element-203" data-mp="ugf5ph286qer">
            {includes.map(item => <li key={item} className="flex gap-2.5" data-id="element-204" data-mp="pj6wi5z21wpn">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#17808D]" aria-hidden="true" data-id="element-205" data-mp="rwsm0wqqi0fe" />
                <span className="text-[14px] font-medium leading-snug text-[#0E3B42]" data-id="element-206" data-mp="vx2ohzfbi8pi">
                  {item}
                </span>
              </li>)}
          </ul>

          <CTAButton className="mt-7" variant="gold" label="Voglio il percorso clinico GLP-1" subline="Download immediato • Accesso a vita • Garanzia di 7 giorni" data-id="element-207" data-mp="15wtmwc7017uv" />

          <div className="mt-8 border-t border-[#0E3B42]/10 pt-7" data-id="element-208" data-mp="d8flrnkm5vf3">
            <Countdown data-id="element-209" data-mp="i6pi41i2r22a" />
          </div>

          <div className="mt-8 flex justify-center" data-id="element-210" data-mp="i5o5hsleu7ig">
            <ScarcityBar data-id="element-211" data-mp="my7gqiwmkqk3" />
          </div>
        </div>
      </div>
    </section>;
}